<template>
  <section class="input-radio default">
    <input
        v-model="computedValue"
        type="radio"
        ref="input"
        :disabled="disabled"
        :required="required"
        :value="nativeValue"
        :name="name"
        :id="id"
    >
    <label class="radio-button" :for="id">
      <span class="check"></span>
      <span class="label">
        <slot name="labelContent">
          {{ label }}
        </slot>
      </span>
    </label>
  </section>
</template>

<script>
import radioMixin from '../_shared/radioMixin';

export default {
  name: 'inputRadioDefault',
  mixins: [radioMixin],
  props: {
    label: String,
  }
};
</script>

